var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsSearchengin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 20 .333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.633 4.844 7.008 5.945V1.441L4.871 8.875l2.137-.945v5.09l2.625-8.176zm-3.25-3.778-.05.184-.595 2.066a4.2 4.2 0 0 0-2.69 3.918c0 2.043 1.339 3.746 3.257 4.121v2.094c-3.043-.41-5.29-3.055-5.29-6.21a6.237 6.237 0 0 1 5.368-6.173zm12.164 17.47c-.437.437-.902.48-1.117.41-.211-.071-1.059-.778-2.36-1.735-1.3-.961-1.312-1.395-1.68-2.215-.366-.816-1.187-1.664-2.245-2.047l-.38-.574c-.964.66-2.07 1.05-3.175 1.121l.082-.258.621-1.933a4.204 4.204 0 0 0 3.16-4.07c0-2.13-1.5-3.989-3.75-4.184V1.016c3.25.199 5.813 2.91 5.813 6.222 0 1.313-.438 2.528-1.133 3.531l.57.375c.383 1.06 1.23 1.875 2.047 2.243.817.367 1.258.379 2.219 1.68.96 1.296 1.668 2.144 1.738 2.355.07.21.028.676-.41 1.113zm-.387-.7a.313.313 0 0 0-.312-.313.313.313 0 0 0-.313.313.313.313 0 0 0 .625 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsSearchengin);
export default __webpack_public_path__ + "static/media/brands-searchengin.6059d335a8edcdb1e0e6a3351b929242.svg";
export { ForwardRef as ReactComponent };